import React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import { NowSSO } from '@foody/fe-common';

import Header from './components/Header/Header';
import Body from './components/Body/Body';
import Footer from './components/Footer/Footer';

import Login from '../pages/Login/Login';
import Loading from '../components/Loading/Loading';
import UniversalModals from './components/UniversalModal/UniversalModals';
import SidebarMenu from './components/SidebarMenu/SidebarMenu';
import ForgotPassword from '../pages/Login/ForgotPassword';
import ChatBox from '../pages/ChatBox/ChatBox';
import GoogleMapWrapper from '../components/GoogleMapComponent/GoogleMapWrapper';
import MigrationConfirm from '../components/migration-confirm';

import { initializeApp } from './actions';

import '../assets/common/scss/core.scss';

class App extends React.Component {
  componentDidMount() {
    const {
      history,
      isReady,
      initializeAppConnect,
      authenticated,
      location,
    } = this.props;
    if (authenticated) {
      if (!isReady) {
        initializeAppConnect();
      }
    } else if (
      location.pathname !== '/account/forgot-password' &&
      location.pathname !== '/account/login'
    ) {
      history.push('/account/login');
    }
  }

  componentDidUpdate(prevProps) {
    const { history, authenticated, location } = this.props;
    const { authenticated: oldAuthenticated } = prevProps;
    if (
      oldAuthenticated &&
      !authenticated &&
      location.pathname !== '/account/login'
    ) {
      history.push('/account/login');
    }
  }

  render() {
    const {
      isReady,
      isLoading,
      authenticated,
      isSidebarCollapse,
      language,
    } = this.props;
    return (
      <div className={`${isSidebarCollapse ? 'sidebar-collapse' : ''}`}>
        <div className="wrapper">
          <Header />
          {!authenticated ? (
            <React.Fragment>
              <Route exact path="/account/login" component={Login} />
              <Route
                exact
                path="/account/forgot-password"
                component={ForgotPassword}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Body />
              <ChatBox />
              <MigrationConfirm />
              <Loading loading={!isReady} />
            </React.Fragment>
          )}
          <Footer />
        </div>
        <SidebarMenu />
        <UniversalModals />
        <Loading loading={isLoading} />
        {!window.google && <GoogleMapWrapper height={1} width={1} />}
        <NowSSO
          otpAppId={CONFIG.OTP_OVER_SMS.APP_ID}
          appType={CONFIG.APP_TYPE}
          clientType="1"
          apiVersion="1"
          clientVersion={CONFIG.CLIENT_VERSION.API}
          clientId="1.0"
          clientLanguage={language || 'vi'}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isReady: state.app.isReady,
  isLoading: state.app.isLoading,
  authenticated: state.auth.authenticated,
  isSidebarCollapse: state.app.isSidebarCollapse,
  language: state.setting.language,
});

const mapDispatchToProps = dispatch => ({
  initializeAppConnect: () => {
    dispatch(initializeApp());
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(App),
);



// WEBPACK FOOTER //
// ./foody/src/layout/App.jsx